import { useEffect } from 'react';

import { useCustomNotificationPopup } from 'src/components/CustomNotificationPopup';
import { useGenericNotificationPopup } from 'src/components/GenericNotificationPopup';

export const PopupNotification = ({ notification, onClickNotification, onCloseNotification }) => {
  const { openGenericNotificationPopup } = useGenericNotificationPopup();
  const { openCustomNotificationPopup } = useCustomNotificationPopup();

  useEffect(() => {
    const openPopup = notification.htmlContent
      ? openCustomNotificationPopup
      : openGenericNotificationPopup;

    openPopup({
      notification,

      onButtonClick: async (linkFromCustomNotificationEvent) => {
        onClickNotification(notification);

        if (linkFromCustomNotificationEvent) {
          window.location = linkFromCustomNotificationEvent;
        } else if (notification.link) {
          window.location.pathname = notification.link;
        }
      },
      onClose: () => {
        onCloseNotification(notification);
      },
    });
  }, [
    notification,
    onClickNotification,
    onCloseNotification,
    openCustomNotificationPopup,
    openGenericNotificationPopup,
  ]);

  return null;
};
